import {FC} from 'react'
import {SelectPageSize} from '../../../components/SelectPageSize/SelectPageSize'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {invoiceSelector, setFilter} from '../../../redux/slices/invoiceSlices'
import {StyledButtonGroups} from '../../../components/StyledButtonGroups'

interface ButtonGroupsProps {
  onSync: () => void
}

export const ButtonGroups: FC<ButtonGroupsProps> = (props) => {
  const {filter} = useAppSelector(invoiceSelector)
  const dispatch = useAppDispatch()

  const handlePageSizeChange = (value: number | undefined | null) => {
    dispatch(setFilter({...filter, per_page: value ?? 5}))
  }

  return (
    <StyledButtonGroups
      leftContent={
        <SelectPageSize
          initialValue={filter?.per_page ?? 5}
          onChange={(value: any) => handlePageSizeChange(value?.value)}
        />
      }
      rightContent={
        <button
          className='btn btn-sm btn-primary'
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          data-bs-trigger='/hover'
          title='Synchronize Invoice'
          onClick={props.onSync}
        >
          <i className='fas fa-sync-alt'></i>
        </button>
      }
    />
  )
}
